import { generateTokens } from './generateTokens.js';

const getTheme = (theme) => {
    return generateTokens(theme);
};

export { getTheme };
//# sourceMappingURL=getTheme.js.map
